import { Layout, theme } from 'antd';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { SiderButton } from '@/v1/main/views/Button';
import { MenuHeader } from '@/v1/main/views/Header';
import { MenuSider } from '@/v1/main/views/Sider';

import styles from './Layout.module.scss';

const { Header, Footer, Content, Sider } = Layout;

export const MainLayout: React.FC = () => {
    const [collapsed, setCollapsed] = useState<boolean>(false);

    const onCollapse = () => setCollapsed(!collapsed);

    const {
        token: { colorPrimaryBg },
    } = theme.useToken();
    return (
        <>
            <Layout className={styles.wrapper}>
                <Header
                    style={{
                        background: colorPrimaryBg,
                    }}
                >
                    <MenuHeader />
                </Header>
                <Content
                    className={styles.main}
                    style={{
                        margin: '0 24px',
                    }}
                >
                    <Outlet />
                </Content>
                <Footer></Footer>
            </Layout>
        </>
    );
};
